<template>
<div aria-label="unm footer" id="footer" role="contentinfo">
  <div class="container">
    <hr>
    <div class="row unmfooter">
      <div class="col-md-9 hidden-xs">
        <div class="row">
          <div aria-label="Academics" class="col-sm-3">
            <h1>Academics</h1>
            <ul class="list-unstyled">
              <li><a href="https://unmevents.unm.edu/site/academic">Academic Calendars</a></li>
              <li><a href="https://schedule.unm.edu/">Class Schedule</a></li>
              <li><a href="https://www.unm.edu/academics/">Colleges &amp; Schools</a></li>
              <li><a href="https://catalog.unm.edu/">Course Catalog</a></li>
              <li><a href="https://degrees.unm.edu/">Degrees &amp; Certificates</a></li>
              <li><a href="https://grad.unm.edu/">Graduate Studies</a></li>
            </ul>
          </div>
          <div aria-label="Campus Life" class="col-sm-3">
            <h1>Campus Life</h1>
            <ul class="list-unstyled">
              <li><a href="https://www.unm.edu/arts/index.html">Arts &amp; Entertainment</a></li>
              <li><a href="https://www.golobos.com">Athletics</a></li>
              <li><a href="https://diverse.unm.edu/">Diversity</a></li>
              <li><a href="https://recsvcs.unm.edu/">Recreational Services</a></li>
              <li><a href="https://sac.unm.edu">Student Activities</a></li>
              <li><a href="https://sub.unm.edu">Student Union</a></li>
            </ul>
          </div>
          <div aria-label="Resources" class="col-sm-3">
            <h1>Resources</h1>
            <ul class="list-unstyled">
              <li><a href="https://bookstore.unm.edu">Bookstore</a></li>
              <li><a href="https://computing.unm.edu">Computing</a></li>
              <li><a href="https://ce.unm.edu">Continuing Education</a></li>
              <li><a href="https://unmjobs.unm.edu">Employment</a></li>
              <li><a href="https://www.unm.edu/libraries/">Libraries</a></li>
              <li><a href="https://news.unm.edu">UNM Newsroom</a></li>
              <!-- site appears to be taken down <li><a href="https://www.icountnm.gov/">I Count NM (Census 2020)</a></li>-->
            </ul>
          </div>
          <div aria-label="Information for..." class="col-sm-3">
            <h1>Information for…</h1>
            <ul class="list-unstyled">
              <li><a href="https://www.unmalumni.com/">Alumni</a></li>
              <li><a href="https://www.unm.edu/facultyandstaff/">Faculty</a></li>
              <li><a href="https://www.unm.edu/parents-families/index.html">Parents &amp; Families</a></li>
              <li><a href="http://hospitals.unm.edu">Patients</a></li>
              <li><a href="https://publicrecords.unm.edu/">Public Records - IPRA</a></li>
              <li><a href="https://www.unm.edu/facultyandstaff/">Staff</a></li>
              <li><a href="https://executivesearch.unm.edu/evp-for-health-sciences/index.html">EVP for Health Sciences
                  Search</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-3 footer-buttons"><a class="btn btn-default btn-lg btn-block"
          href="https://www.unm.edu/apply"><strong><span class="fa-check fa">&nbsp;</span> APPLY</strong> Now</a><a
          class="btn btn-default btn-lg btn-block" href="https://admissions.unm.edu/visit-us/"><strong><span
              class="fa-calendar fa">&nbsp;</span> Visit</strong> UNM</a><a class="btn btn-default btn-lg btn-block"
          href="https://www.unmfund.org/"><strong><span class="fa-gift fa">&nbsp;</span> Give</strong> to UNM</a></div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-8">
        <p><a href="https://www.unm.edu"><img alt="The University of New Mexico"
              src="https://webcore.unm.edu/v2/images/unm-transparent-white.png"></a></p>
        <p class="small">© The University of New Mexico <br> Albuquerque, NM 87131, (505) 277-0111 <br> New Mexico's
          Flagship University</p>
      </div>
      <div class="col-md-4">
        <ul class="list-inline">
          <li><a href="https://www.facebook.com/universityofnewmexico" title="UNM on Facebook">
            <i class="fa-brands fa-facebook fa-2x"></i><span class="sr-only">UNM on Facebook</span></span></a></li>
          <li><a href="https://instagram.com/uofnm" title="UNM on Instagram"><i class="fa-brands fa-instagram fa-2x"></i><span
                  class="sr-only">UNM on Instagram</span></span></a></li>
          <li><a href="https://twitter.com/unm" title="UNM on Twitter"><i class="fa-brands fa-x-twitter fa-2x"></i><span
                  class="sr-only">UNM on Twitter</span></span></a></li>
          <li><a href="https://www.youtube.com/user/unmlive" title="UNM on YouTube"><i class="fa-brands fa-youtube fa-2x"></i><span class="sr-only">UNM on YouTube</span></span></a></li>
        </ul>
        <p>more at <a class="link-underline" href="https://social.unm.edu"
            title="UNM Social Media Directory &amp; Information">social.unm.edu</a></p>
        <ul class="list-inline" id="unm_footer_links">
          <li><a href="http://webmaster.unm.edu/support">Website Comments</a></li>
          <li><a href="https://www.unm.edu/accessibility.html">Accessibility</a></li>
          <li><a href="https://www.unm.edu/legal.html">Legal</a></li>
          <li><a href="https://www.unm.edu/contactunm.html">Contact UNM</a></li>
          <li><a href="https://www.unm.edu/consumer-information/">Consumer Information</a></li>
          <li><a href="https://hed.state.nm.us/resources-for-schools/public_schools/tableau-charts-and-tables">New
              Mexico Higher Education Dashboard</a></li>
          <li><a href="https://finaid.unm.edu/cares-act.html">CARES Act</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>



// WEBPACK FOOTER //
// unm_footer.vue?4627e6df